import dayjs from 'dayjs';

const defaultParams = {
   listhrly: {
        product:"listhrly",
        linkTo: "/listhrly",
        displayName: "Hourly data listing",
        productCategory: "hourly",
        elems: [23, 5],
        sid: "",
        stnName: "",
        datePickerViews: ['year','month','day'],
        fromDate: dayjs().set('date', 1).subtract(1, 'month'),
        toDate: dayjs(),
        fromFilterMonth: 1,
        toFilterMonth: 12,
        fromFilterDay: 1,
        toFilterDay: 31,
        fromFilterHour: 1,
        toFilterHour: 24, 
        variables: ['clds', 'vis', 'wx', 'temp', 'dwpt', 'rhum', 'wspd', 'wdir', 'wgust', 'pres', 'slp', 'pcpn'], 
        output: 'html',
    },
    monhrly: {
        product:"monhrly",
        linkTo: "/monhrly",
        displayName: "Hourly data for a month",
        productCategory: "hourly",
        elems: [23, 5],
        sid: "",
        stnName: "",
        datePickerViews: ['year','month'],
        fromDate: dayjs().subtract(1, 'month'),
        fromFilterHour: 1,
        toFilterHour: 24,
        variable: "temp",
    },
    meteogrf: {
        product:"meteogrf",
        linkTo: "/meteogrf",
        displayName: "Time series graph",
        productCategory: "hourly",
        elems: [23, 5],
        sid: "",
        stnName: "",
        datePickerViews: ['year','month', 'day'],
        fromDate: dayjs().subtract(14, 'day'),
        toDate: dayjs(),
        variables: ["temp","dwpt","rhum","tsky","pcpn","wspd","wgust","altp","pres"],
    },
    monsmry: {
        product:"monsmry",
        linkTo: "/monsmry",
        displayName: "Monthly summarized hourly data",
        productCategory: "hourly",
        elems: [23, 5],
        sid: "",
        stnName: "",
        datePickerViews: ['year','month'],
        fromDate: dayjs().set('month', 0).set('date', 1).subtract(1, 'year'),
        toDate: dayjs().endOf('month'),
        fromFilterMonth: 1,
        toFilterMonth: 12,
        fromFilterHour: 1,
        toFilterHour: 24,
        variable: "temp",
        smry: "cnthrs",
        operator: "le",
        thresh: 32,
        allowMissing: 10,
        wxvariables: [],
    },
    exthrly: {
        product:"exthrly",
        linkTo: "/exthrly",
        displayName: "Hourly data extremes",
        productCategory: "hourly",
        elems: [23, 5],
        sid: "",
        stnName: "",
        datePickerViews: ['year','month','day'],
        fromDate: dayjs().set('month', 0).set('date', 1).subtract(1, 'year'),
        toDate: dayjs(),
        fromFilterMonth: 1,
        toFilterMonth: 12,
        fromFilterDay: 1,
        toFilterDay: 31,
        fromFilterHour: 1,
        toFilterHour: 24,
        variable: "temp",
        smry: "max",
        numrec: 10,
        numhrs: 1,
    },
    conhrly: {
        product:"conhrly",
        linkTo: "/conhrly",
        displayName: "Consecutive hours extremes",
        productCategory: "hourly",
        elems: [23, 5],
        sid: "",
        stnName: "",
        datePickerViews: ['year','month','day'],
        fromDate: dayjs().set('month', 0).set('date', 1).subtract(1, 'year'),
        toDate: dayjs(),
        fromFilterMonth: 1,
        toFilterMonth: 12,
        fromFilterDay: 1,
        toFilterDay: 31,
        variable: "temp",
        smry: null,
        operator: "ge",
        thresh: 90,
        numrec: 10,
    },
//    occhrly: {
//        product: "occhrly",
//        linkTo: "/occhrly",
//        displayName: "Occurrence distribution",
//        productCategory: "hourly",
//        elems: [23],
//        sid: "",
//        stnName: "",
//        fromFilterYear: dayjs().year()-30,
//        toFilterYear: dayjs().year()-1,
//        variable: "temp",
//        smry: "hrofmax"
//    },
    windrose: {
        product:"windrose",
        linkTo: "/windrose",
        displayName: "Wind roses",
        productCategory: "hourly",
        elems: [27, 28],
        sid: "",
        stnName: "",
        pctcnt: "percent",
        directbincnt: 36,
        wsunits: "miles/hr",
        speedbins: [0, 5, 10, 15, 20, 25, 30, 35, 40, 45],
        fromDate: dayjs().subtract(1, 'year'),
        toDate: dayjs(),
        fromFilterMonth: 1,
        toFilterMonth: 12,
        fromFilterDay: 1,
        toFilterDay: 31,
        fromFilterHour: 1,
        toFilterHour: 24,
        output: { graph:true, table:true },
    },
    bintemps: {
        product: "bintemps",
        linkTo: "/bintemps",
        displayName: "Bin temperature summary",
        productCategory: "hourly",
        elems: [23, 25],
        sid: "",
        stnName: "",
        fromDate: dayjs().subtract(1, 'year'),
        toDate: dayjs(),
        fromFilterMonth: 1,
        toFilterMonth: 12,
        fromFilterHour: 1,
        toFilterHour: 24,
        weekdays: [0,1,2,3,4,5,6],
        binsize: 5,
        moreOptions: { estimation:true },
        output: { each_month:true, annual:true }
    },
/*    placeholder: {
        product:"placeholder",
        displayName: "Forthcoming daily data product",
        productCategory: "daily-ss",
    },*/
     gridmap: {
        product:"gridmap",
        linkTo: "/gridmap",
        displayName: "Gridded data maps",
        productCategory: "gridded",
        grid: "nrcc-nn",
        areaType: "",
        area: "",
        fromDate: dayjs().subtract(7, 'day'),
        toDate: dayjs().subtract(1, 'day'),
        variable: "pcpn",
        units: "inch",
        smry: "sum",
        operator: "ge",
        thresh: 90,
        interp: "cspline",
        overlays: { state: true, county: true },
        clevels: Array(10).fill(""),
        cmap: "",
        colors: [],
    },
}

// return parameters for product
export function productParams(product) {
    return defaultParams[product];
}

// element used by specified product
export function productElems(product) {
    return defaultParams[product].elems;
}

// return list of all product codes corresponding display name
export function productList() {
    const plist = [];
    Object.values(defaultParams).forEach((val) => {
        plist.push({product: val.product, displayName: val.displayName, productCategory: val.productCategory, linkTo: val.linkTo})
    })
    return plist;
}
